import { render, staticRenderFns } from "./CareerAptitudeTestQuestionsTable.vue?vue&type=template&id=323bc863&"
import script from "./CareerAptitudeTestQuestionsTable.vue?vue&type=script&lang=js&"
export * from "./CareerAptitudeTestQuestionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports